import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import {
    AbstractControl,
    FormControl,
    NG_VALUE_ACCESSOR,
    ValidationErrors,
    Validator,
    ControlContainer
} from '@angular/forms';
import { ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'sm-ui',
    template: '',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SmUiComponent),
            multi: true
        }
    ]
})
export abstract class SmUiComponent implements ControlValueAccessor, Validator, OnInit {
    controlContainer;
    formcontrol;
    @Input() props;

    constructor(protected injector: Injector) {
       
        this.controlContainer = this.injector.get(ControlContainer);
    }

    ngOnInit(): void {
        this.formcontrol = this.controlContainer.control.get(this.props.field_Name);
    }

    writeValue(value: any): void {
    
    }

    registerOnChange(fn: any): void {}

    registerOnTouched(fn: any): void {}

    setDisabledState?(isDisabled: boolean): void {
      
    }

    setControl(control: any) {
        this.formcontrol = control;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        this.formcontrol = control;
        return control;
    }
}
